export default "__VITE_ASSET__DPs0KGOP__"